<template>
    <ReferralsContainer
        :errorSlug="errorSlug"
        :beforeInit="beforeInit"
        :afterInit="afterInit"
    />
</template>

<!-- Separate script tag needed for custom fetchData and vuex logic, to be used in entry-server and entry-client -->
<script>
// eslint-disable-next-line import/no-duplicates
import referralsModule, { REFERRALS_MODULE_NAME } from '~routes/referrals/js/referrals-store';

const vuex = {
    moduleName: REFERRALS_MODULE_NAME,
    module: referralsModule,
};

export default {
    vuex,
};
</script>

<script setup>
/* eslint-disable import/first */
import { computed, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';

import { useGetters, useMutations } from '~coreModules/core/js/composables/vuexHelpers';

import { PROFILE_MODULE_NAME } from '~modules/profile/js/profile-store';
// eslint-disable-next-line import/no-duplicates
import { SET_FRIENDBUY_CLICK } from '~routes/referrals/js/referrals-store';
import { rentalRouteNames } from '~modules/core/js/router-constants';
import { CONTENT_SLUGS } from '~modules/contentful/js/contentful-constants';
import { FRIENDBUY_REFERRAL_TYPES } from '~routes/referrals/js/referrals-constants';

import ReferralsContainer from '~routes/referrals/components/ReferralsContainer.vue';
/* eslint-enable import/first */

const router = useRouter();
const route = useRoute();

const { isAnonymousOrNonSubscriber } = useGetters(PROFILE_MODULE_NAME, ['isAnonymousOrNonSubscriber']);

const { setFriendbuyClick } = useMutations(REFERRALS_MODULE_NAME, {
    setFriendbuyClick: SET_FRIENDBUY_CLICK,
});

const errorSlug = ref(null);

const referralInviteLink = computed(() => {
    const inviteRoute = {
        name: rentalRouteNames.referrals.invite,
    };

    if (route.query?.type === FRIENDBUY_REFERRAL_TYPES.INFLUENCER) {
        inviteRoute.query = {
            type: FRIENDBUY_REFERRAL_TYPES.INFLUENCER,
        };
    }

    return inviteRoute;
});

function beforeInit() {
    const { referralCode } = route.query;

    if ((!referralCode) || !isAnonymousOrNonSubscriber.value) {
        errorSlug.value = CONTENT_SLUGS.REFERRALS_EMAIL_CAPTURE_INELIGIBLE_SLUG;
        return false;
    }

    return true;
}

function afterInit(friendbuyAPI) {
    friendbuyAPI.push(['getVisitorStatus', (response) => {
        const { payload } = response;

        if (payload.isSelfReferral || payload.referralCodeBlocked) {
            errorSlug.value = CONTENT_SLUGS.SELF_REFERRAL_EMAIL_CAPTURE_SLUG;
        } else {
            setFriendbuyClick(true);
            router.push(referralInviteLink.value);
        }
    }]);
}

</script>

<style lang="scss">

</style>
